import React from "react";
import { css } from "@emotion/css";
import { Spinner, SpinnerSize } from "@fluentui/react";

const loadingCss = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 150px;
`;

export interface ILoadingSpinnerPros {
  label: string;
}

const LoadingSpinner: React.FunctionComponent<ILoadingSpinnerPros> = (props) => {
  return (
    <div className={loadingCss}>
      <Spinner label={`${props.label}...`} ariaLive="polite" size={SpinnerSize.large} />
    </div>
  );
};

export default LoadingSpinner;
